import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isInitializing } = useAuth();
  const location = useLocation();

  console.log('ProtectedRoute check:', { 
    user: !!user, 
    userDetails: user,
    isInitializing,
    location: location.pathname,
    timestamp: new Date().toISOString()
  });

  // Wait for auth initialization to complete before checking user
  if (isInitializing) {
    console.log('Auth still initializing, waiting...');
    return <div>Loading...</div>; // Or a proper loading spinner
  }

  if (!user) {
    console.log('No user found after initialization, redirecting to login');
    // Redirect to login page with the return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  console.log('User authenticated, rendering protected content');
  return <>{children}</>;
};

export default ProtectedRoute;
